
import '@npo/player/src/style/npoplayer.css'
import { overflowContainerMixin } from '../../mixins'

export default {
  name: 'EoNpoPlayer2',
  mixins: [
    overflowContainerMixin,
  ],
  model: {
    prop: 'playing',
    event: 'update:playing',
  },
  props: {
    /**
     * Media ID from POMS (https://pomslookup.eo.nl/)
     */
    id: {
      type: String,
      default: '',
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    playing: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
    fragments: {
      type: Array,
      default: () => [],
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    liveOffset: {
      type: Boolean,
      default: false,
    },
    liveProgramTime: {
      type: Number,
      default: null,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    poster: {
      type: String,
      default: null,
    },
    startOffset: {
      type: Number,
      default: null,
    },
    subtitleTracks: {
      type: Array,
      default: () => [],
    },
    thumbnailTrack: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      instance: null,
      status: null,
      uid: null,
      duration: null,
    }
  },
  watch: {
    id: {
      handler: function () {
        this.initiatePlayer()
      },
      immediate: true,
    },
    hidden: {
      handler: function (shouldHide) {
        if (!shouldHide) {
          this.initiatePlayer()
        } else if (this.instance) {
          this.instance.player?.pause()
          this.instance = undefined
        }
      },
      immediate: true,
    },
    playing: {
      handler: function () {
        if (
          !this.instance ||
          (this.playing && this.status == 'playing') ||
          (!this.playing && this.status === 'paused')
        ) {
          return
        }
        if (this.playing) {
          this.instance.player?.play()
          this.status = 'playing'
        } else {
          this.instance.player?.pause()
          this.status = 'paused'
        }
        this.$emit('update:playing', this.playing)
      },
      immediate: true,
    },
  },
  mounted () {
    this.uid = this._uid
    if (!window.NpoPlayer) {
      window.NpoPlayer = require('@npo/player/lib/npoplayer.js')
    }
    this.initiatePlayer()
  },
  methods: {
    async initiatePlayer () {
      if (!this.id || this.hidden || !this.$refs['embed']) return
      if (!this.instance) {
        this.instance = new window.NpoPlayer.default({
          container: this.$refs['embed'],
          playerConfig: {
            key: this.$config.playerKey,
            analytics: {
              key: this.$config.playerAnalyticsKey,
            },
            cast: {
              enable: true,
            },
            playback: {
              muted: this.muted,
              autoplay: this.autoplay,
            },
            events: {
              ready: () => {
                this.status = 'ready'
                this.duration = this.instance.player.getDuration()
                this.$emit('ready', this.duration)
                if (this.autoplay) {
                  this.status = 'playing'
                  this.$emit('update:playing', true)
                }
              },
              play: () => {
                this.status = 'playing'
                this.$emit('update:playing', true)
              },
              paused: () => {
                this.status = 'paused'
                this.$emit('update:playing', false)
              },
              timechanged: (event) => {
                this.$emit('time-changed', event.time, this.duration)
              },
              durationchanged: (event) => {
                this.duration = event.to
                this.$emit('duration-changed', event.to, event.from)
              },
              playbackfinished: () => {
                this.status = 'ended'
                this.$emit('update:playing', false)
                this.$emit('ended')
              },
            },
          },
          brand: this.$library.npoTag.brand,
          brand_id: this.$library.npoTag.brandId,
          platform_version: this.$library.npoTag.platformVersion,
        },
        )
      }

      this.instance.loadStream(
        await this.$library.api.get('/poms/jsonwebtoken', {
          params: {
            tokenName:'eo',
            prid: this.id,
          },
        }).then(res => res?.data?.item),
        {
          sourceConfig: {
            title: this.title,
            description: this.description,
            poster: this.poster,
            thumbnailTrack: this.thumbnailTrack,
            subtitleTracks: this.subtitleTracks,
            analytics: {
              title: this.title,
            },
          },
          startOffset: this.startOffset,
          liveProgramTime: this.liveProgramTime,
          liveOffset: this.liveOffset,
        },
      )
    },
  },
}
